import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Question } from '../../content/hooks/useUnansweredQuestions';
import React from 'react';
import Typography from '@mui/material/Typography';
import styles from '../styles/AlertWarning.module.css';

interface AlertWarningProps {
  showOpen: boolean;
  questionsNotsaved: Question[];
  unansweredQuestions: Question[];
  goToQuestion: (id: number) => void;
  handleClose: () => void;
  handleContinue: () => void;
}
export default function AlertWarning(props: AlertWarningProps) {
  const {
    showOpen,
    questionsNotsaved,
    unansweredQuestions,
    goToQuestion,
    handleClose,
    handleContinue
  } = props;

  interface DisplayQuestionProps {
    questions: Question[];
  }
  const DisplayQuestions = (props: DisplayQuestionProps) => {
    return (
      <ul>
        {props.questions.map((q) => {
          const questionText = document.querySelector(
            `.question-${q.componentkey}`
          )?.textContent;
          return (
            <li key={q.componentkey} className={styles.list}>
              <Typography
                onClick={() => {
                  goToQuestion(q.componentkey);
                }}
                className={styles.typographyLink}
              >
                {questionText
                  ? questionText
                  : `${q.questionType} type question`}
              </Typography>
            </li>
          );
        })}
      </ul>
    );
  };

  return (
    <Dialog
      open={showOpen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Unsaved/Unanswered Questions
      </DialogTitle>
      <DialogContent>
        {questionsNotsaved.length > 0 && (
          <>
            You have not saved the answers of the following questions.
            <DisplayQuestions questions={questionsNotsaved} />
          </>
        )}
        {unansweredQuestions.length > 0 && (
          <>
            You have {unansweredQuestions.length} unanswered questions.
            <DisplayQuestions questions={unansweredQuestions} />
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="contained" color="primary" onClick={handleContinue}>
          Ignore and Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
}
